import React, { Component } from 'react';
import { connect } from 'react-redux';
import TableHeader from '../../../helper/tableHeader';

class Header extends Component {
  render() {
    let items = [
        `Price (${this.props.market.denomination})`,
        `Amt (${this.props.market.asset})`,
        `Total (${this.props.market.denomination})`,
        `Cml (${this.props.market.denomination})`
    ]
    return (
      <TableHeader items={items} />
		)
  }
}

function mapStateToProps(state,props) {
  return {
    market: state.ui_marketplace.market
  };
}

export default connect(mapStateToProps, {})(Header);
